import namespace from './namespace';
import utils from './../../utils';
import {mapUsersByEmailResultEnum} from "./enums/mapUsersByEmailResultEnum";

export default  {
    [namespace.getters.DEFAULT_VALUES]: (state) => {
        return state[namespace.state.DEFAULT_VALUES];
    },
    [namespace.getters.AVAILABLE_VALUES]: (state) => {
        let availableValues = state[namespace.state.AVAILABLE_VALUES];
        let jiraValues = [];
        let tfsValues = [];
        if (availableValues.length !== 0) {
            availableValues.forEach(value => value.visible = true);
            jiraValues = availableValues.filter(value => value.kind === 'JIRA')
                                        .sort(utils.compareByLabel);
            tfsValues = availableValues.filter(value => value.kind === 'TFS')
                                       .sort(utils.compareByLabel);
        }

        return {
            TfsValues: tfsValues,
            JiraValues: jiraValues
        };
    },
    [namespace.getters.SPECIAL_VALUES]: (state) => {
        return state[namespace.state.SPECIAL_VALUES];
    },
    [namespace.getters.IS_LOADER_VISIBLE]: (state) => {
        return state[namespace.state.LOADER_VISIBLE];
    },
    mapUsersByEmailResult: state => state.mapUsersByEmailResult,
    showMappedByEmailFlag: state => !(state.mapUsersByEmailResult === mapUsersByEmailResultEnum.NONE),
    mapUsersByEmailResultMessage: state => state.mapUsersByEmailResultMessage
};


// WEBPACK FOOTER //
// ./src/store/modules/usersMapping/getters.js